import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import { DeletePatientDiv, DeleteText, BackAndDeleteDiv, BackButton, DeleteButton } from "./styles";
import Axios from "../../../../config/axios";

const DeleteMessage = ({
  COACH_MESSAGES_PER_PATIENT_ID,
  setIsShowingDeleteCanvas,
  setIsLoadingMessages,
  rechargeMessages,
  setRechargeMessages,
}) => {
  const [t] = useTranslation("global");

  const handleDeleteMessage = (e) => {
    e.preventDefault();
    Axios("get", `${WEB_SERVICE_MIMS}/coach-messages/delete-message/${COACH_MESSAGES_PER_PATIENT_ID}`)
      .then(({ data }) => {
        if (data.deletedMessage) {
          toast.success(t("coachMessages_alerts_deletedMessageSuccessfully"));
          setIsLoadingMessages(true);
          setRechargeMessages(!rechargeMessages);
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("Endpoint to delete message", error);
      });
  };

  return (
    <DeletePatientDiv>
      <DeleteText>{t("coachMessages_confirmDeleteMessage")}</DeleteText>
      <BackAndDeleteDiv>
        <BackButton onClick={() => setIsShowingDeleteCanvas(false)}>{t("cancel")}</BackButton>
        <DeleteButton onClick={handleDeleteMessage}>{t("delete")}</DeleteButton>
      </BackAndDeleteDiv>
    </DeletePatientDiv>
  );
};

export default DeleteMessage;
